<template>
<div class="crosaudio">
  <audio ref="crosaudio"></audio>
</div>
</template>
<script>
export default {
  name: 'crosaudio',
  data() {
    return {
      audio: null,
    };
  },
  mounted() {
    this.audio = this.$refs.crosaudio;
  },
};
</script>



// WEBPACK FOOTER //
// CrosAudio.vue?91bd40e2